import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tooltip absolute whitespace-nowrap px-4 py-2 -top-10 left-0 z-10 rounded bg-blue-900 text-white font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.text ? _ctx.text : 'No Description Available'), 1))
}